import { render, staticRenderFns } from "./HorizontalListMenu.vue?vue&type=template&id=ffec3618"
import script from "./HorizontalListMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalListMenu.vue?vue&type=script&lang=js"
import style0 from "./HorizontalListMenu.vue?vue&type=style&index=0&id=ffec3618&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports